/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
const naucohaiduong = require("../acssets/naucohaiduong.png");
const co34 = require("../acssets/co34.png");
const c = require("../acssets/xuan-quynh.jpg");
const d = require("../acssets/minh-nghiem.jpg");
const imgs = [
  {
    link: "https://img6.thuthuatphanmem.vn/uploads/2022/04/16/hinh-nen-gai-xinh-quyen-ru-full-hd_084903054.jpg",
    img: naucohaiduong,
  },
  {
    link: "https://img6.thuthuatphanmem.vn/uploads/2022/04/16/anh-nen-gai-xinh-2k-dep-cho-may-tinh_084855596.jpg",
    img: co34,
  },
  {
    link: "blob:https://www.facebook.com/52aecdee-d306-4995-baa9-9288a3a75b86",
    img: c,
  },
  {
    link: "https://blogger.googleusercontent.com/img/a/AVvXsEi6405cJtTmYgkAnn4kCGzSt2yTKzxoueTzqAzV7gRZ2lj574BQ0xLpiPHujwuIBLIREOxgbRfwWzvL8vfvatCgl4l9VkSEz_-wowKIRnTHK9FMbSI8nSfGI50ZpLtKLQ9qQOQlYKHM7PbQGcDggZ_71dg_eBDJcbmxnbxwcmZD-0ghfSHlRBQx6KEP_Q",
    img: d,
  },
];
const SlideBar = () => {
  return (
    <div className="md:h-[560px] lg:h-[580px]  h-[300px] mt-[118px] sm:mt-[108px] lg:mt-[92px]">
      <Swiper
        style={{ height: "100%" }}
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        {imgs.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div
                style={{
                  backgroundRepeat: "round",
                  backgroundImage:
                    "url(https://wallpapercave.com/wp/wp3104899.jpg)",
                }}
                className="w-full h-full relative"
              >
                <img className="object-contain h-full w-full " src={item.img} />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default SlideBar;
